import {
  SIGNUP_LANGUAGE_DATA_KEY,
  SIGNUP_LANGUAGE_PARAM,
  SIGNUP_REGIME_PARAM,
  signupLanguageFrom,
} from "@vidimo/shared";

/** The parameters a marketing trial link carries into signup. */
const TRIAL_LINK_PARAMS = [SIGNUP_LANGUAGE_PARAM, SIGNUP_REGIME_PARAM];

/**
 * What a sign-up or social sign-in request adds so the server records the
 * language the trial link carried: better-auth's `additionalData`, which the
 * email form sends in its body and a redirect sign-in carries through the
 * provider in its state. The server reads it only when the request opens an
 * account, so a sign-in to an existing one sends it harmlessly.
 *
 * Read off the URL at the moment of sending, as the regime is, and kept
 * nowhere else: it lasts exactly as long as the link it came on, and cannot
 * reach an account opened later in the same tab by someone who never
 * followed it.
 */
export function signupLanguageData(search: string): {
  additionalData?: Record<string, string>;
} {
  const language = signupLanguageFrom(
    new URLSearchParams(search).get(SIGNUP_LANGUAGE_PARAM)
  );
  return language
    ? { additionalData: { [SIGNUP_LANGUAGE_DATA_KEY]: language } }
    : {};
}

/**
 * The trial link's parameters, as a query to carry on a move between signup
 * and sign-in, so a reader who switches between them before opening the
 * account still has both: the language to record and the regime whose
 * exception signup names. Everything else on the URL stays behind.
 */
export function trialLinkQuery(search: string): string {
  const current = new URLSearchParams(search);
  const carried = new URLSearchParams();
  for (const param of TRIAL_LINK_PARAMS) {
    const value = current.get(param);
    if (value) {
      carried.set(param, value);
    }
  }
  const query = carried.toString();
  return query ? `?${query}` : "";
}
